// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { List, ListItem } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from '../../../../components/MDBox';
import MDTypography from '../../../../components/MDTypography';
import MDButton from '../../../../components/MDButton';

// Material Dashboard 2 React context
import { useMaterialUIController } from '../../../../context';

// react-router-dom components
import { useNavigate } from "react-router-dom";
import { useCimbeo } from '../../../../context';

function ProjectOverview({data}) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { setProjectName, setProjectId } = useCimbeo();

    const navigate = useNavigate();
  
    const clickAnalyze = async () => {
      // Set project name in context and navigate to 
      console.log("Setting project name and id");
      setProjectName(data.title);
      setProjectId(data.id);
      navigate("/asset-explorer");
    }

  return (
    <Card sx={{height: "100%",  overflow: "auto"}}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={2}>
        <MDTypography variant="h4" fontWeight="medium" textTransform="capitalize">
          {data.title}
        </MDTypography>
        <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
            <MDButton variant="gradient" color="gold" onClick={clickAnalyze} sx={{color: "navy.main"}}>
                <Icon>analytics</Icon>&nbsp;analyze
            </MDButton>
        </MDBox>
      </MDBox>
      <MDBox pb={2} px={2} display="flex" justifyContent="space-between" flexDirection="column">
        <MDBox
            component="li"
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            bgColor="navy"
            borderRadius="lg"
            p={3}
            mb={1}
            mt={2}
        >
            <MDBox width="100%" display="flex" flexDirection="column">
                <MDTypography variant="body1" fontWeight="medium" textTransform="capitalize">
                    Description
                </MDTypography>

                <MDBox mt={1} mb={1}>
                    <MDTypography variant="body2" component="p" color="text">
                        {data.description}
                    </MDTypography>
                </MDBox>
            </MDBox>
        </MDBox>
        <MDBox pb={2} display="flex" justifyContent="space-between" flexDirection="column">
            <MDBox
                component="li"
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                bgColor="navy"
                borderRadius="lg"
                p={3}
                mb={1}
                mt={2}
            >
                <MDBox width="100%" display="flex" flexDirection="column">
                    <MDBox>
                        <MDTypography variant="body1" fontWeight="medium" textTransform="capitalize">
                            Information
                        </MDTypography>
                    </MDBox>

                    <MDBox mt={2}>
                        <MDTypography variant="body2" fontWeight="medium" color="text">
                            Assets:
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                            {data.assetCount}
                        </MDTypography>
                    </MDBox>
                    <MDBox mt={2}>
                        <MDTypography variant="body2" fontWeight="medium" color="text">
                            Artifacts Ingested:
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                            {data.documents.length}
                        </MDTypography>
                    </MDBox>
                    <MDBox mt={2}>
                        <MDTypography variant="body2" fontWeight="medium" color="text">
                            Decomposed Artifacts:
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                            Mission Needs: {data.numMissionNeeds}
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                            Capabilities: {data.numCapabilities}
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                            ConOps: {data.numConOps}
                        </MDTypography>
                        <MDTypography variant="body2" color="text">
                            Requirements: {data.numRequirements}
                        </MDTypography>
                    </MDBox>
                </MDBox>
            </MDBox>
        </MDBox>
        {/*
        <MDBox
            component="li"
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            bgColor={darkMode ? "transparent" : "grey-300"}
            borderRadius="lg"
            p={3}
            mb={1}
            mt={2}
        >
            <MDBox width="100%" display="flex" flexDirection="column">
                <MDTypography variant="body1" fontWeight="medium" textTransform="capitalize">
                    Requirements
                </MDTypography>

                <MDBox mt={1} mb={1}>
                    <List sx={{listStyle: "decimal", pl: 3}}>
                        {data.requirements.map((item) => (
                            <ListItem sx={{ display: 'list-item' }}>
                                <MDTypography variant="body1" component="p" color="text">
                                    {item.title}
                                </MDTypography>
                                <MDTypography variant="body2" component="p" color="text">
                                    {item.description}
                                </MDTypography>
                            </ListItem>
                        ))}
                    </List>
                </MDBox>
            </MDBox>
        </MDBox>
        */}
      </MDBox>
    </Card>
  );
}

export default ProjectOverview;